import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileJson"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M23.25 8.25V15.75H21.75L20.25 11.25V15.75H18.75V8.25H20.25L21.75 12.75V8.25H23.25ZM16.0005 15.75H14.0002C13.3102 15.7496 12.7508 15.1905 12.75 14.5005V9.50025C12.7504 8.81022 13.3095 8.25083 13.9995 8.25H15.9998C16.6898 8.25041 17.2492 8.80947 17.25 9.4995V14.4998C17.2496 15.1898 16.6905 15.7492 16.0005 15.75ZM14.25 14.25H15.75V9.75H14.25V14.25ZM10.0005 15.75H6.75V14.25H9.75V12.75H8.25C7.42192 12.7492 6.75083 12.0781 6.75 11.25V9.4995C6.75083 8.80976 7.30976 8.25083 7.9995 8.25H11.25V9.75H8.25V11.25H9.75C10.5781 11.2508 11.2492 11.9219 11.25 12.75V14.4998C11.2496 15.1898 10.6905 15.7492 10.0005 15.75ZM3.99975 15.75H2.00025C1.31022 15.7496 0.750827 15.1905 0.75 14.5005V12.75H2.25V14.25H3.75V8.25H5.25V14.5005C5.24917 15.1905 4.68978 15.7496 3.99975 15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileJson.vue"]]);
